<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter">
            <b-menu>
              <b-menu-list :label="$t('viewGES1point5Results.label-3')">
                <b-menu-item
                  @click="activate('ghg-protocol')"
                  :active="activeModule === 'ghg-protocol'"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="dot-circle-o"></b-icon>
                          {{ $t('ghg-protocol') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
                <b-menu-item
                  @click="activate('regulatory-inventory')"
                  :active="activeModule === 'regulatory-inventory'"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="bank"></b-icon>
                          {{ $t('viewGES1point5Results.label-1') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
                <b-menu-item
                  @click="activate('carbon-footprint-synthesis')"
                  :active="activeModule === 'carbon-footprint-synthesis'"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="paw"></b-icon>
                          {{ $t('viewGES1point5Results.label-2') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <div class="column">
            <ghg-protocol v-if="activeModule === 'ghg-protocol'" />
            <regulatory-inventory
              v-if="activeModule === 'regulatory-inventory'"
            />
            <carbon-footprint-synthesis
              v-if="activeModule === 'carbon-footprint-synthesis' && loaded"
              ref="syntheseEmpreinte"
              :isPublic="true"
            />
            <ges-data v-if="activeModule === 'ges-data'" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'GES1point5Results',
  components: {
    'ghg-protocol': () => import('@/components/carbon/results/GHGProtocol.vue'),
    'regulatory-inventory': () =>
      import('@/components/carbon/results/RegulatoryInventory.vue'),
    'carbon-footprint-synthesis': () =>
      import('@/components/carbon/results/CarbonFootprintSynthesis.vue')
  },
  data () {
    return {
      activeModule: 'carbon-footprint-synthesis',
      loaded: false
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    return { ghgiStore }
  },
  computed: {
    uuid: function () {
      return this.$route.params.uuid
    }
  },
  methods: {
    activate: function (module) {
      this.activeModule = module
    }
  },
  mounted () {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    this.ghgiStore.init()
    this.ghgiStore
      .setFromUUID(this.uuid)
      .then((data) => {
        this.loaded = true
        loadingComponent.close()
      })
      .catch((error) => {
        if (error.response.status === 404) {
          loadingComponent.close()
          this.$router.push('/not-found')
        }
        throw error
      })
  }
}
</script>

<style>
.menu-list a.is-active {
  background-color: rgba(52, 59, 64, 0.7) !important;
  color: white;
}
</style>

<style scoped>
.dropdown .dropdown-menu .has-link a,
a.dropdown-item,
button.dropdown-item {
  text-align: center;
}
</style>
